export type VehicleCatalogueFuelTypeProperties =
  | {name: 'secondary_fuel_type'; value: string[]}
  | {name: 'fuel_unit'; value: string};
